/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateReminderMutationRequest,
  CreateReminderMutationResponse,
  CreateReminder400,
  CreateReminder500,
} from '../types/CreateReminder'

function getCreateReminderUrl() {
  const res = { method: 'POST', url: `/api/v1/reminders/reminders/` as const }
  return res
}

/**
 * @description Create a new reminder.
 * Delegates to CreateReminderUsecase for business logic.
 * @summary Create a new reminder
 * {@link /api/v1/reminders/reminders/}
 */
export async function createReminder(
  data: CreateReminderMutationRequest,
  config: Partial<RequestConfig<CreateReminderMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateReminderMutationResponse,
    ResponseErrorConfig<CreateReminder400 | CreateReminder500>,
    CreateReminderMutationRequest
  >({
    method: 'POST',
    url: getCreateReminderUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
